export const benefitsTranslations = {
  es: {
    benefits: {
      sectionLabel: "Impacto Clínico",
      title: "Resultados",
      titleHighlight: "Medibles",
      description: "Evidencia clínica real de las soluciones que habilitamos.",
      items: [
        {
          category: "Imagenología",
          icon: "radiology",
          stats: [
            { value: "53%", label: "reducción en tiempo de lectura" },
            { value: "99.97%", label: "Valor Predictivo Negativo" },
            { value: "23%", label: "aumento en detección de cáncer" },
            { value: "52%", label: "mejora en eficiencia operativa" },
          ],
        },
        {
          category: "Dermatología",
          icon: "dermatology",
          stats: [
            { value: "81.1%", label: "sensibilidad diagnóstica con IA (vs. 75% sin IA)" },
            { value: "+13pts", label: "mejora en sensibilidad en médicos no dermatólogos" },
            { value: "38%", label: "reducción de derivaciones innecesarias" },
            { value: "56%", label: "disminución en tiempos de espera" },
          ],
        },
        {
          category: "Cardiología",
          icon: "cardiology",
          stats: [
            { value: "70%", label: "reducción en tiempo de informe ecocardiográfico" },
            { value: "159s", label: "tiempo de medición (vs. 325s manual)" },
            { value: "71s", label: "creación de informe (vs. 429s manual)" },
          ],
        },
        {
          category: "Laboratorio Clínico",
          icon: "science",
          stats: [
            { value: "6–33%", label: "mejora en adherencia al tratamiento documentada en ensayos aleatorizados" },
          ],
        },
        {
          category: "Salud Mental",
          icon: "psychology",
          stats: [
            { value: "75%", label: "sensibilidad en detección de depresión (biomarcadores de voz)" },
            { value: "70%", label: "especificidad en detección de ansiedad" },
            { value: "10–15s", label: "tiempo de análisis de voz por paciente" },
          ],
        },
      ],
    },
  },
  en: {
    benefits: {
      sectionLabel: "Clinical Impact",
      title: "Measurable",
      titleHighlight: "Results",
      description: "Real clinical evidence from the solutions we enable.",
      items: [
        {
          category: "Imaging",
          icon: "radiology",
          stats: [
            { value: "53%", label: "reduction in reading time" },
            { value: "99.97%", label: "Negative Predictive Value" },
            { value: "23%", label: "increase in cancer detection" },
            { value: "52%", label: "improvement in operational efficiency" },
          ],
        },
        {
          category: "Dermatology",
          icon: "dermatology",
          stats: [
            { value: "81.1%", label: "diagnostic sensitivity with AI (vs. 75% without)" },
            { value: "+13pts", label: "sensitivity improvement in non-dermatologist physicians" },
            { value: "38%", label: "reduction in unnecessary referrals" },
            { value: "56%", label: "decrease in waiting times" },
          ],
        },
        {
          category: "Cardiology",
          icon: "cardiology",
          stats: [
            { value: "70%", label: "reduction in echocardiography report time" },
            { value: "159s", label: "measurement time (vs. 325s manual)" },
            { value: "71s", label: "report creation (vs. 429s manual)" },
          ],
        },
        {
          category: "Clinical Laboratory",
          icon: "science",
          stats: [
            { value: "6–33%", label: "improvement in treatment adherence documented in randomized trials" },
          ],
        },
        {
          category: "Mental Health",
          icon: "psychology",
          stats: [
            { value: "75%", label: "sensitivity in depression detection (voice biomarkers)" },
            { value: "70%", label: "specificity in anxiety detection" },
            { value: "10–15s", label: "voice analysis time per patient" },
          ],
        },
      ],
    },
  },
};
